export default __webpack_public_path__ + "static/media/hospital.840a8b91.jpg";